import AccountLayout from '@/account/account-layout.vue';
import { RouteConfig } from 'vue-router';

const SetPasswordRouting: RouteConfig[] = [
    {
        path: '/account',
        component: AccountLayout,
        children: [
            {
                path: 'setPassword',
                component: () => import(/* webpackChunkName: "account" */ './setPassword/setPassword.vue'),
            },
        ],
    },
];

export default SetPasswordRouting;
